require('./hirePromotion.scss');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const moment = require('moment');
const PropTypes = require('prop-types');

// @ commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKInput } = require('commonsComponents/OKInput');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @ Contact Center
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// constants
const { PROMOTION_SET_CODE } = require('constants/operationTypes');


class HirePromotion extends React.Component {
    constructor(props) {
        super(props);

        const valueInput = props.valueInput;
        this.state = {
            checkboxTermsValue: false,
            inputPromotionValue: valueInput ? valueInput : ''
        };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCheckboxTermsChange = this.handleCheckboxTermsChange.bind(this);
        this.handleClaimPromotionFinish = this.handleClaimPromotionFinish.bind(this);
        this.handleGetPromotionClick = this.handleGetPromotionClick.bind(this);
        this.handlePromotionInputChange = this.handlePromotionInputChange.bind(this);
        this.handleOnCancelPromotionalCode = this.handleOnCancelPromotionalCode.bind(this);
    }

    buildPreContractualMailInfo() {
        const { immProfileFields, immPrecontractualMail, requestProfile, sendPreContractualMail } = this.props;
        const profileError = immProfileFields.get('error');
        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const sendMailParams = {
            promotionalCode: this.state.inputPromotionValue
        }

        return (
            <PreContractualMailInfo
                email={clientEmail}
                sendEmail={sendPreContractualMail}
                requestProfile={requestProfile}
                preContractualMail={immPrecontractualMail}
                profileError={profileError}
                sendMailParams={sendMailParams}
                showLegalText={false}
            />
        );
    }

    buildContactCenterCheckBox() {
        const {immPromotions, immPrecontractualMail} = this.props;
        const {checkboxTermsValue, inputPromotionValue} = this.state;
        const isMailSent = immPrecontractualMail.get('mailSent');
        const immPromotion = immPromotions.getIn(['byId', inputPromotionValue]);
        const previewUrlTerms = immPromotion.get('url');

        const link = (
            <OKLink
                modifier="emphasize"
                extraClass="hire-promotion__preview-terms-link"
                to={previewUrlTerms}
                target="_blank"
            >
                <FormattedText value="promotions-termsLinkPromotionPreview"/>
            </OKLink>
        );

        const previewCheckboxLabel = (
            <div className="hire-promotion__preview-terms">
                <FormattedTextWithComponents value="promotions-contactCenterCheckboxText" injectedComponents={[link]}/>
            </div>
        );

        return (
            <BlockInfo hasCheckbox >
                <OKCheckbox
                    idName="chkPreviewPromotion"
                    label={previewCheckboxLabel}
                    value={checkboxTermsValue}
                    onChange={this.handleCheckboxTermsChange}
                    disabled={!isMailSent}
                />
            </BlockInfo>
        );
    }

    buildPromotionAlreadyHiredError() {
        return (
            <OKMessage type="important">
                {formatText('promotions-alreadyHiredPromotion')}
            </OKMessage>
        )
    }

    getInputErrorMessage() {
        const { immPromotions } = this.props;
        let inputErrorMessage = '';

        if (immPromotions.get('fetchingPromotionError') !== '') {
            inputErrorMessage = formatText('promotions-inputErrorMessagePromotionError');
        } else if (this.isPromotionExpired()) {
            inputErrorMessage = formatText('promotions-inputErrorMessagePromotionExpired');
        }

        return inputErrorMessage;
    }

    getPromotionButtonBlock() {
        const { immPromotions } = this.props;
        const { inputPromotionValue } = this.state;
        const isFetchingPromotion = immPromotions.get('isFetchingPromotion');
        let dataToRender = (
            <OKButton id="btnGetPromotion"
                disabled={inputPromotionValue === ''}
                modifier="secondary"
                size="regular"
                onClick={this.handleGetPromotionClick}
                loading={isFetchingPromotion}
            >
                <FormattedText value="promotions-getPromotionButton" />
            </OKButton>
        );

        if (this.isPromotionalCodeValid()) {
            dataToRender = (
                <span className="hire-promotion__icon-container">
                    <i className="hire-promotion__icon icon icon-check" />
                </span>
            );
        }

        return dataToRender;
    }

    getPromotionPreviewBlock() {
        const { immPromotions } = this.props;
        const { checkboxTermsValue, inputPromotionValue } = this.state;
        let dataToRender = null;

        if (this.isPromotionalCodeValid()) {
            const immPromotion = immPromotions.getIn(['byId', inputPromotionValue]);
            const previewSubTitle = immPromotion.get('subTitle');
            const previewTitle = immPromotion.get('title');
            const previewUrlImg = immPromotion.get('urlImg');
            const previewUrlTerms = immPromotion.get('url');
            const isPromotionAlreadyHired = immPromotions.get('isPromotionAlreadyHired');
            const previewCheckboxLabel = (
                <div className="hire-promotion__preview-terms">
                    <FormattedText value="promotions-termsPromotionPreview" />
                    <OKLink modifier="emphasize" extraClass="hire-promotion__preview-terms-link"
                        to={previewUrlTerms}
                        target="_blank"
                    >
                        <FormattedText value="promotions-termsLinkPromotionPreview" />
                    </OKLink>
                </div>
            );

            const promotionPreviewImageClass = contactCenterClassName('no-print-out', 'hire-promotion__preview-image');
            dataToRender = (
                <OKSectionBox className="hire-promotion__preview-content">
                    <OKBoxTitle value={formatText('promotions-titleHeaderPromotionPreview')} />
                    <div className="row hire-promotion__preview-container">
                        <div className="col-xs-4">
                            <img className={promotionPreviewImageClass} src={previewUrlImg} />
                        </div>
                        <div className="col-xs-8">
                            <div className="hire-promotion__preview-title">
                                {previewTitle}
                            </div>
                            <div className="hire-promotion__preview-subtitle">
                                {previewSubTitle}
                            </div>
                            <OKButton
                                modifier="link-emphasize"
                                onClick={this.handleOnCancelPromotionalCode}
                                id="btn_cancel_promotion_code_request"
                            >
                                <FormattedText value="promotions-doNotApplyPromotion" />
                            </OKButton>
                        </div>
                    </div>

                    {!isPromotionAlreadyHired && <WebappRender>
                        <footer className="hire-promotion__preview-footer">
                            <OKCheckbox idName="chkPreviewPromotion"
                                label={previewCheckboxLabel}
                                value={checkboxTermsValue}
                                onChange={this.handleCheckboxTermsChange}
                            />
                        </footer>
                    </WebappRender>}

                </OKSectionBox>
            );
        }

        return dataToRender;
    }

    buildSignaturePatternSection() {
        const { checkboxTermsValue } = this.state;
        const operationParams = {};
        let dataToRender = null;

        if (checkboxTermsValue) {
            dataToRender = (
                <SignaturePattern
                    operationType={PROMOTION_SET_CODE}
                    operationParams={operationParams}
                />
            );
        }

        return dataToRender;
    }

    handleCheckboxTermsChange(evt) {
        this.setState({
            checkboxTermsValue: evt.target.checked
        });
    }

    handleClaimPromotionFinish() {
        this.props.onFinish(this.state.inputPromotionValue)
    }

    handleGetPromotionClick() {
        this.props.onGetPromotion(this.state.inputPromotionValue)
    }

    handleOnCancelPromotionalCode() {
        const { cancelPromotionalCode, resetPrecontractualMail } = this.props;
        __CONTACT_CENTER__ && resetPrecontractualMail();
        cancelPromotionalCode();
    }

    handlePromotionInputChange(evt) {
        evt.preventDefault();
        const newInputValue = evt.target.value.toUpperCase();
        this.props.onChange(newInputValue);
        this.setState({
            inputPromotionValue: newInputValue
        });
    }

    isPromotionExpired() {
        const { immPromotions } = this.props;
        const { inputPromotionValue } = this.state;
        const immPromotion = immPromotions.getIn(['byId', inputPromotionValue]);
        let promotionState = false;

        if (immPromotion) {
            const endPromotionDate = moment(immPromotion.get('finish')).add(1, 'd');
            promotionState = moment().isAfter(endPromotionDate);
        }

        return promotionState;
    }

    isPromotionalCodeValid() {
        const { immPromotions } = this.props;
        const { inputPromotionValue } = this.state;
        const immPromotion = immPromotions.getIn(['byId', inputPromotionValue]);
        const isFetchingPromotion = immPromotions.get('isFetchingPromotion');
        const fetchPromotionSuccess = (immPromotion) ? immPromotions.get('fetchPromotionSuccess') : false;
        return (!isFetchingPromotion && fetchPromotionSuccess && !this.isPromotionExpired());
    }

    buildContactCenterInfo() {
        const isPromotionalCodeValid = this.isPromotionalCodeValid();
        const operative = formatText('operatives-promotions');

        if (!isPromotionalCodeValid) return null;

        return (
            <div>
                {this.buildPreContractualMailInfo()}
                {this.buildContactCenterCheckBox()}
                <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}/>
            </div>
        );
    }

    render() {
        const { immPromotions, onCancel } = this.props;
        const { checkboxTermsValue, inputPromotionValue } = this.state;
        const isSettingPromotion = immPromotions.get('isSettingPromotion');
        const isDisabled = this.isPromotionalCodeValid();
        const isPromotionAlreadyHired = immPromotions.get('isPromotionAlreadyHired');
        const errorState = (immPromotions.get('fetchingPromotionError') !== '' || this.isPromotionExpired());
        const inputErrorMessage = this.getInputErrorMessage();
        const promotionButtonBlock = this.getPromotionButtonBlock();
        const promotionPreview = this.getPromotionPreviewBlock();
        const buildPromotionAlreadyHiredError = this.buildPromotionAlreadyHiredError();
        const buildSignaturePatternSection = this.buildSignaturePatternSection();
        const promotionsInputLabelClass = contactCenterClassName('no-print-out', 'hire-promotion__input-title');
        const promotionsInputContainerClass = contactCenterClassName('no-print-out', 'col-xs-5 hire-promotion__input-container');

        return (
            <OKSectionBox>
                <OKBoxTitle value={formatText('promotions-titleHeader')} />
                <section id="printable-wizard" className="hire-promotion__content">
                    <div className={promotionsInputLabelClass}>
                        <FormattedText value="promotions-inputLabel" />
                    </div>
                    <div className="row">
                        <div className={promotionsInputContainerClass}>
                            <OKInput id="inpPromotion"
                                disabled={isDisabled}
                                value={inputPromotionValue}
                                onChange={this.handlePromotionInputChange}
                                errorState={errorState}
                                errorMessage={inputErrorMessage}
                            />
                        </div>
                        <div className="col-xs-7">
                            {promotionButtonBlock}
                        </div>
                    </div>
                    {promotionPreview}

                    {!isPromotionAlreadyHired && <ContactCenterRender>
                        {this.buildContactCenterInfo()}
                    </ContactCenterRender>}
                    
                    {!isPromotionAlreadyHired && buildSignaturePatternSection}
                    {isPromotionAlreadyHired && buildPromotionAlreadyHiredError}
                </section>
                <footer className="hire-promotion__buttons">
                    <div className="hire-promotion__cancel-button">
                        <OKButton id="btnCancelPromotion"
                            modifier="link-ghost"
                            onClick={onCancel}
                        >
                            <FormattedText value="promotions-cancelButton" />
                        </OKButton>
                    </div>
                    <div className="hire-promotion__finish-button">
                        <OKButton id="btnClaimPromotion"
                            disabled={(!checkboxTermsValue || isPromotionAlreadyHired)}
                            onClick={this.handleClaimPromotionFinish}
                            loading={isSettingPromotion}
                        >
                            <FormattedText value="promotions-finishButton" />
                        </OKButton>
                    </div>
                </footer>
            </OKSectionBox>
        );
    }
}

HirePromotion.propTypes = {
    cancelPromotionalCode: PropTypes.func,
    immPrecontractualMail: PropTypes.object,
    immProfileFields: PropTypes.object,
    immPromotions: PropTypes.object.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onGetPromotion: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    valueInput: PropTypes.string
};

module.exports = HirePromotion;
